<template>
    <div class="sample-detail">
        <a-breadcrumb separator=">">
            <a-breadcrumb-item>
                <router-link to="/sample">
                    <img src="../../assets/control/breadcrumb.svg" style="margin: 0 4px 4px 0" />控制样
                </router-link>
            </a-breadcrumb-item>
            <a-breadcrumb-item>
                <router-link to="/sample/sample-search">控制样查询</router-link>
            </a-breadcrumb-item>
            <a-breadcrumb-item>控制样详情</a-breadcrumb-item>
        </a-breadcrumb>

        <div class="flow">
            <custom-form ref="static-form" :readonly="true" :panels="baseFields" :fieldsValue="baseValue"></custom-form>

            <a-form class="dynamic-form">
                <a-form-item
                    v-for="field in dynamicFields"
                    :key="field.sampleTypeParameterId"
                    :label="field.parametername"
                    :label-col="{ span: 6 }"
                    :wrapper-col="{ span: 18 }"
                >
                    <a-input disabled :value="field.parameterValue ?? '-'"></a-input>
                </a-form-item>
            </a-form>

            <div class="btns">
                <a-button @click="close">返回</a-button>
            </div>
        </div>
    </div>
</template>

<script>
import customForm from '@/components/custom-form.vue';
import { getSampleDynamicIpt, getSampleOrderDetail } from '../../common/api';

export default {
    components: { customForm },

    data() {
        return {
            baseFields: [
                {
                    id: 'baseFields',
                    gutter: 12,
                    fieldGroup: [
                        [
                            {
                                label: '订购类型',
                                field: 'sampletypename',
                                span: 12,
                                labelCol: { span: 6 },
                                wrapperCol: { span: 18 }
                            },
                            {
                                label: '订购单位名称',
                                field: 'clientName',
                                span: 12,
                                labelCol: { span: 6 },
                                wrapperCol: { span: 18 }
                            }
                        ],
                        [
                            {
                                label: '订购单位地址',
                                field: 'clientAddress',
                                span: 12,
                                labelCol: { span: 6 },
                                wrapperCol: { span: 18 }
                            },
                            {
                                label: '联系人姓名',
                                field: 'contactName',
                                span: 12,
                                labelCol: { span: 6 },
                                wrapperCol: { span: 18 }
                            }
                        ],
                        [
                            {
                                label: '联系电话',
                                field: 'contactPhone',
                                span: 12,
                                labelCol: { span: 6 },
                                wrapperCol: { span: 18 }
                            },
                            {
                                label: '邮编',
                                field: 'zipCode',
                                span: 12,
                                labelCol: { span: 6 },
                                wrapperCol: { span: 18 }
                            }
                        ],
                        [
                            {
                                label: '传真',
                                field: 'fax',
                                span: 12,
                                labelCol: { span: 6 },
                                wrapperCol: { span: 18 }
                            },
                            {
                                label: '备注',
                                field: 'remark',
                                span: 12,
                                labelCol: { span: 6 },
                                wrapperCol: { span: 18 }
                            }
                        ]
                    ]
                }
            ],
            baseValue: {
                sampletypename: '',
                clientAddress: '',
                contactName: '',
                contactPhone: '',
                zipCode: '',
                fax: '',
                remark: '',
                clientName: ''
            },
            dynamicFields: []
        };
    },

    computed: {
        orderId() {
            return this.$route.query?.id;
        }
    },

    mounted() {
        this.getDynamicList();
        this.getDetail();
    },

    methods: {
        async getDynamicList() {
            if (!this.orderId) {
                return this.$message.error('缺少订单id');
            }
            const { data } = await getSampleDynamicIpt(this.orderId);
            this.dynamicFields = data.ordersParamterList.map(t => {
                return {
                    ...t.ext$,
                    ...t
                };
            });
        },

        async getDetail() {
            const { data } = await getSampleOrderDetail(this.orderId);
            this.baseValue.sampletypename = data.ext$.sampletypename;
            for (const key in this.baseValue) {
                if (data[key]) {
                    this.baseValue[key] = data[key];
                }
            }
            this.$nextTick(() => {
                this.$refs['static-form'].form.setFieldsValue(this.baseValue);
            });
        },

        close() {
            this.$router.back();
        }
    }
};
</script>

<style lang="scss" scoped>
.sample-detail {
    width: 1200px;

    .flow {
        background: #ffffff;
        border-radius: 4px;
        padding: 16px;

        ::v-deep {
            .dynamic-form {
                display: flex;
                justify-content: space-between;
                .ant-form-item {
                    width: 50%;
                }
            }

            .ant-input[disabled] {
                border: none;
                color: #333333;
                background: transparent;
                cursor: default;
            }
        }
        .btns {
            display: flex;
            justify-content: center;
            margin-top: 40px;

            .ant-btn {
                width: 120px;
            }
        }
    }
}
</style>
